import {
  InstallationStatusName,
  useGetInstallationFullQuery
} from 'generated/graphql';
import React from 'react';

export interface IData {
  name: string;
  type: string;
  isComplete: boolean;
  statusName: InstallationStatusName;
  statusDisplayName: string;

}

export function useQuery(id: string) {
  const tuple = useGetInstallationFullQuery({
    variables: {
      id
    },
    skip: id === ''
  });

  return React.useMemo(
    () => {
      const data: IData = {
        name: `${tuple.data?.installation?.name}`,
        type: `${tuple.data?.installation?.area.displayName} ${tuple.data?.installation?.subArea.displayName}`,
        isComplete: tuple.data?.installation?.status.name === 'complete' ? true : false,
        statusName: tuple.data?.installation?.status.name ?? 'toDo',
        statusDisplayName: tuple.data?.installation?.status.displayName ?? ''
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
